import React from 'react';

const reportFrontendDebug = (event, payload = {}) => {
  try {
    if (typeof window !== 'undefined' && typeof window.__allowtruReportFrontendDebug === 'function') {
      window.__allowtruReportFrontendDebug(event, payload);
    }
  } catch (_) {}
};

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    reportFrontendDebug('error_boundary_caught', {
      error_message: error?.message || String(error),
      error_name: error?.name || '',
      error_stack: error?.stack || '',
      component_stack: errorInfo?.componentStack || '',
    });
    console.error('ErrorBoundary caught render error:', error, errorInfo);
  }

  componentDidUpdate(prevProps) {
    if (prevProps.resetKey !== this.props.resetKey && this.state.hasError) {
      reportFrontendDebug('error_boundary_reset', {
        previous_reset_key: prevProps.resetKey || '',
        next_reset_key: this.props.resetKey || '',
      });
      this.setState({ hasError: false, error: null });
    }
  }

  resetBoundary = () => {
    this.setState({ hasError: false, error: null });
  };

  handleReload = () => {
    try {
      // 尝试清理语言/缓存，提升兼容性
      localStorage.removeItem('i18nextLng');
    } catch (e) {}
    this.resetBoundary();
    window.location.reload();
  };

  render() {
    if (this.state.hasError) {
      return (
        <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#f7f8fa', padding: 24 }}>
          <div style={{ maxWidth: 560, background: '#fff', border: '1px solid #eee', borderRadius: 12, boxShadow: '0 6px 20px rgba(0,0,0,0.08)', padding: 24 }}>
            <h2 style={{ marginTop: 0 }}>页面出现问题</h2>
            <p style={{ color: '#666' }}>已启用兼容性回退。您可以尝试刷新或访问联系页面。</p>
            <div style={{ display: 'flex', gap: 12 }}>
              <button onClick={this.handleReload} style={{ padding: '8px 16px', borderRadius: 8, border: '1px solid #1890ff', background: '#1890ff', color: '#fff', cursor: 'pointer' }}>刷新页面</button>
              <button onClick={this.resetBoundary} style={{ padding: '8px 16px', borderRadius: 8, border: '1px solid #ddd', background: '#fff', color: '#333', cursor: 'pointer' }}>重试当前页面</button>
              <a href="/contact" style={{ padding: '8px 16px', borderRadius: 8, border: '1px solid #ddd', background: '#fff', color: '#333', textDecoration: 'none' }}>前往联系页</a>
            </div>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
